import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from '../../../redux/store';
import { CompletedOrderView, PendingOrderView } from '../../../components/dashboard/orders/order';
import { getPreviousOrderInfo, getPendingOrderInfo, getRerunOrderInfo } from '../../../redux/slices/orders';

export default function Order() {
  const { id = '' } = useParams();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const filter = searchParams.get('filter');
  const vendorId = searchParams.get('vendorId');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (filter === 'previous') {
        const vendorFilter = vendorId && vendorId !== 'all' ? vendorId : null;
        dispatch(getPreviousOrderInfo(id, () => navigate(`/dashboard/orders/${id}?filter=pending`), vendorFilter));
      }
      else if (filter === 'rerun') dispatch(getRerunOrderInfo(id, vendorId));
      else dispatch(getPendingOrderInfo(id, false, () => navigate(`/dashboard/orders/${id}?filter=previous`)));  
    };

    fetchData();
  }, [filter, id, vendorId]);

  return (
    <>
      <Helmet>
        <title>Order | Platform Solutions</title>
      </Helmet>

      {filter === 'previous' ? <CompletedOrderView /> : <PendingOrderView filter={filter} />}
    </>
  );
}
